export const AUTH_USER = 'auth_user',
  GOT_USERDATA = 'got_userdata',
  USER_UPDATED = 'user_updated',
  INVITES_POSTED = 'invites_posted',
  CHAT_OPENED = 'chat_opened',
  CHAT_TOGGLED = 'chat_toggled',
  CHAT_CLOSED = 'chat_shut',
  CHAT_ADDED_USER = 'chat_added_user',
  CHAT_RENAMED = 'chat_renamed',
  TYPING_SET = 'typing_set',
  MESSAGE_SENT = 'message_sent',
  UNAUTH_USER = 'unauth_user',
  AUTH_ERROR = 'auth_error',
  UPDATE_FOLDER_CHAIN = 'update_folder_chain',
  GOT_ACCOUNT_DATA = 'got_account_data',
  CLEARED_ACCOUNT_DATA = 'cleared_accont_data',
  COMMENT_LIKED = 'comment_liked',
  TASK_LOADING_DATA = 'task_loading_data',
  TASK_SET_CURRENT = 'task_set_current',
  OPEN_MODAL = 'open_modal',
  CLOSE_MODAL = 'close_modal',
  PROJECT_UPDATED = 'project_updated',
  PROJECT_GOT_DATA = 'project_got_data',
  PROJECT_SET_SLUG = 'project_set_slug',
  PROJECT_STATUSES_SAVED = 'project_statuses_saved',
  FOLDER_ORDER_UPDATED = 'fglder_order_updated',
  TODODAY_ADDED = 'tododay_added',
  TODODAY_CHANGED = 'tododay_changed',
  FILE_VERSION_DELETED = 'file_version_deleted',
  NOTIFICATIONS_SEEN = 'notifications_seen',
  NOTIFICATION_OPENED = 'notification_opened',
  NOTIFICATIONS_CLEARED = 'notifications_cleared',
  SUBSCRIBER_TOGGLED = 'subscriber_toggled',
  PAGE_TITLE_CHANGED = 'page_title_changed';
